export function resetPasswordMutationDefinition() {
  return {
    url: '/api/users/password.json',
    method: 'PUT'
  };
}
